import { SWR_KEYS } from "../Utilities/swrKeys";
// Filters only order-related SWR keys
export const filterOrdersKeys = (key) => {
    return (typeof key === "string" && (key.startsWith(SWR_KEYS.UPCOMING_ORDERS) || key.startsWith(SWR_KEYS.ORDERS_BY_DATE)));
};
export var LOADING_STATES;
(function (LOADING_STATES) {
    LOADING_STATES["IS_LOADING_ORDERS"] = "Loading Orders...";
    LOADING_STATES["IS_MUTATING_ORDERS"] = "Updating Orders!";
    LOADING_STATES["IS_VALIDTAING_ORDERS"] = "Validating Orders!";
})(LOADING_STATES || (LOADING_STATES = {}));
